import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import TopBar from "../components/TopBar";
import { useToast } from "../context/ToastContext";
import "bootstrap/dist/css/bootstrap.min.css";
import { Table, Button, Modal, Form, InputGroup, FormControl, Badge, Tooltip, OverlayTrigger, Pagination } from "react-bootstrap";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link"],
    ["clean"]
  ]
};

const quillFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "align",
  "link"
];

const AdminBlogs = () => {
  const toast = useToast();
  const [blogs, setBlogs] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editBlog, setEditBlog] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState("");
  const [category, setCategory] = useState("");
  const categories = ["General", "Skin Care", "Hair Care", "Medical Engineering", "Donation"];
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [blogToDelete, setBlogToDelete] = useState(null);

  // Filters & Search
  const [searchTerm, setSearchTerm] = useState("");
  const [filterCategory, setFilterCategory] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  useEffect(() => {
    fetchBlogs();
  }, []);

  // const fetchBlogs = async () => {
  //   try {
  //     const response = await axios.get(`${process.env.REACT_APP_API_URL}/blogs`);
  //     setBlogs(response.data);
  //   } catch (error) {
  //     console.error("Error fetching blogs:", error);
  //   }
  // };
  const fetchBlogs = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/blogs`);
      // ✅ Sort blogs by newest first (most recent at the top)
      const sortedBlogs = response.data.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      setBlogs(sortedBlogs);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setImageName(file ? file.name : "");
  };

  const handleSaveBlog = async () => {
    if (!title || !description || !image || !category) {
      alert("Please fill in all fields.");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("image", image);
    formData.append("category", category);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/blogs/add`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        setBlogs([...blogs, data.blog]);
        setShowModal(false);
        resetForm();
        toast.showToast("Blog added successfully!", "success");
      } else {
        alert("Error saving blog: " + data.message);
      }
    } catch (error) {
      console.error("Error saving blog:", error);
    }
  };

  const handleDeleteClick = (blog) => {
    setBlogToDelete(blog);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/blogs/${blogToDelete._id}`, {
        method: "DELETE",
      });
      setBlogs(blogs.filter((blog) => blog._id !== blogToDelete._id));
      setShowDeleteModal(false);
      toast.showToast("Blog deleted successfully!", "danger");
    } catch (error) {
      console.error("Error deleting blog:", error);
    }
  };

  const handleEditClick = (blog) => {
    setEditBlog(blog);
    setTitle(blog.title);
    setDescription(blog.description);
    setImage(null);
    setImageName(blog.image);
    setCategory(blog.category || "");
    setShowModal(true);
  };

  const handleUpdateBlog = async () => {
    if (!title || !description || !category) {
      alert("Please fill in all fields.");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    if (image) formData.append("image", image);
    formData.append("category", category);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/blogs/${editBlog._id}`,
        { method: "PUT", body: formData }
      );

      if (response.ok) {
        setShowModal(false);
        setEditBlog(null);
        resetForm();
        fetchBlogs();
        toast.showToast("Blog updated successfully!", "success");
      } else {
        alert("Error updating blog.");
      }
    } catch (error) {
      console.error("Error updating blog:", error);
    }
  };

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setImage(null);
    setImageName("");
    setCategory("");
  };

  // Filtered & searched blogs
  const filteredBlogs = blogs
    .filter((blog) =>
      blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.description.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter((blog) => (filterCategory ? blog.category === filterCategory : true));

  // Pagination logic
  const totalPages = Math.ceil(filteredBlogs.length / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredBlogs.slice(indexOfFirstRecord, indexOfLastRecord);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar setIsSidebarOpen={setIsSidebarOpen} />
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          transition: "margin-left 0.3s ease",
          marginLeft: isSidebarOpen ? "250px" : "80px",
          padding: "20px",
        }}
      >
        <TopBar />
        <div className="container-fluid mt-4">

          {/* Header */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">

            <Button
              className="mb-2 mb-md-0"
              onClick={() => {
                setShowModal(true);
                setEditBlog(null);
                resetForm();
              }}
            >
              Add New Blog
            </Button>
          </div>

          {/* Search & Filter */}
          <div className="d-flex flex-column flex-md-row mb-3 gap-2 align-items-start align-items-md-center">
            <InputGroup style={{ maxWidth: "300px" }}>
              <FormControl
                placeholder="Search by title or description..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </InputGroup>
            <Form.Select
              style={{ maxWidth: "200px" }}
              value={filterCategory}
              onChange={(e) => setFilterCategory(e.target.value)}
            >
              <option value="">All Categories</option>
              {categories.map((cat, idx) => (
                <option key={idx} value={cat}>{cat}</option>
              ))}
            </Form.Select>
          </div>

          {/* Table */}
          <div className="table-responsive shadow-sm rounded p-2 bg-white">
            <Table striped bordered hover className="mb-0">
              <colgroup>
                <col style={{ width: "20%" }} />
                <col style={{ width: "35%" }} /> {/* Description reduced width */}
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
              </colgroup>
              <thead className="table-dark">
                <tr>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Category</th>
                  <th>Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentRecords.map((blog) => (
                  <tr key={blog._id}>
                    <td>{blog.title}</td>
                    <td>
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{blog.description}</Tooltip>}
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: blog.description.slice(0, 80) + "...",
                          }}
                        />
                      </OverlayTrigger>
                    </td>
                    <td><Badge bg="info">{blog.category}</Badge></td>
                    <td>
                      <img
                        src={`${process.env.REACT_APP_IMAGE_BASE_URL}/uploads/${blog.image}`}
                        alt="Blog"
                        width="100"
                        className="rounded"
                      />
                    </td>
                    <td>
                      <div className="d-flex gap-2 flex-nowrap">
                        <Button
                          variant="primary"
                          size="sm"
                          onClick={() => handleEditClick(blog)}
                        >
                          Edit
                        </Button>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => handleDeleteClick(blog)}
                        >
                          Delete
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {filteredBlogs.length === 0 && (
              <div className="text-center py-4">No blogs found.</div>
            )}

            {/* Pagination */}
            {totalPages > 1 && (
              <Pagination className="mt-3 justify-content-center">
                {[...Array(totalPages)].map((_, idx) => (
                  <Pagination.Item
                    key={idx + 1}
                    active={currentPage === idx + 1}
                    onClick={() => paginate(idx + 1)}
                    style={{
                      backgroundColor: currentPage === idx + 1 ? "#547296" : undefined, // primary color
                      borderColor: currentPage === idx + 1 ? "#547296" : undefined,
                      color: currentPage === idx + 1 ? "white" : undefined
                    }}
                  >
                    {idx + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            )}
          </div>

          {/* Add/Edit Modal */}
          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="md"
            centered
          >
            <Modal.Header>
              <Modal.Title>{editBlog ? "Edit Blog" : "Add New Blog"}</Modal.Title>
              <Button
                variant="close"
                onClick={() => setShowModal(false)}
                style={{ border: "none", background: "transparent" }}
              />
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <ReactQuill
                    theme="snow"
                    value={description}
                    onChange={setDescription}
                    modules={quillModules}
                    formats={quillFormats}
                    placeholder="Write blog content here..."
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                  >
                    <option value="">-- Select Category --</option>
                    {categories.map((cat, idx) => (
                      <option key={idx} value={cat}>{cat}</option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Image</Form.Label>
                  <Form.Control type="file" onChange={handleFileChange} />
                  {editBlog && <Form.Text>Current File: {imageName}</Form.Text>}
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer className="justify-content-end">
              {editBlog ? (
                <Button variant="primary" onClick={handleUpdateBlog}>
                  Update
                </Button>
              ) : (
                <Button variant="primary" onClick={handleSaveBlog}>
                  Save
                </Button>
              )}
            </Modal.Footer>
          </Modal>

          {/* Confirm Delete Modal */}
          <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Deletion</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete the blog titled <strong>{blogToDelete?.title}</strong>?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </Button>
              <Button variant="danger" onClick={confirmDelete}>
                Delete
              </Button>
            </Modal.Footer>
          </Modal>

        </div>
      </div>
    </div>
  );
};

export default AdminBlogs;
